module.exports = __webpack_public_path__ + "img/michael_deiter.17896f00.png";